export default "__VITE_ASSET__DbTECjAe__"